import { render, staticRenderFns } from "./UtochRequestTable.vue?vue&type=template&id=76583d4f&scoped=true&"
import script from "./UtochRequestTable.vue?vue&type=script&lang=js&"
export * from "./UtochRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./UtochRequestTable.vue?vue&type=style&index=0&id=76583d4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76583d4f",
  null
  
)

export default component.exports